import { useNavigate } from "react-router-dom";
import { GUEST_ROUTES } from 'routes/routes';
import styled from "styled-components";
import { ICharacter } from 'types/characters';


interface ICharacterProps {
  character: ICharacter;
}

const CharacterCard: React.FC<ICharacterProps> = (props) => {
  const { character } = props;
  const navigate = useNavigate();

  const handleCardClick = () => navigate(GUEST_ROUTES.CHARACTER(character.id));

  const coverURL = character?.coverURL ?? character.avatar;

  return (
    <Card onClick={handleCardClick}>
      <Cover src={coverURL} alt={character.name} />
      <BottomSection>
        <Name>{character.name}</Name>
        <Description>{character.description}</Description>
      </BottomSection>
    </Card>
  );
};

export default CharacterCard;

const Card = styled.div`
  width: 308px;
  height: 396px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    width: 100%;
    height: 440px;
  }
`;

const Cover = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const BottomSection = styled.div`
  position: absolute;
  bottom: -1px;
  width: 100%;
  padding: 32px 16px 24px 16px;
  background: linear-gradient(180deg, rgba(29, 29, 29, 0.00) 0%, rgba(29, 29, 29, 0.70) 32.89%, #100D0B 100%);
  color: #fff;
`;

const Name = styled.span`
  font-family: Raleway, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
`;

const Description = styled.p`
  margin-top: 4px;
  font-family: Nunito Sans;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #A9A9A9;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
